import { Space } from 'antd'
import GenerateSingleButton from './components/GenerateSingleButton'
import ReportSample from './components/ReportSample'
import { useReportRecordSelectContext } from 'components/CIMSSelect/common/ReportRecordSelect/ReportRecordSelectContext'
import { useSingleReportsContext } from './SingleReportsContext'
import ReportRecordSelect from 'components/CIMSSelect/common/ReportRecordSelect'
import ReportSelect from 'components/CIMSSelect/common/ReportSelect'
import { Report } from '@cims-online/shared'
import { LabeledValueType } from 'components/CIMSSelect/types'

const SingleReports: React.FC = () => {
  const { value, report, setValue, setReport } = useSingleReportsContext()
  const { loading } = useReportRecordSelectContext()
  return (
    <Space direction="vertical" size="large">
      <Space>
        <ReportSelect
          onChange={(id) => setReport(Report.fromId(id as string))}
          value={report?.id}
          style={{ minWidth: 300, width: 'fit-content' }}
          disabled={loading}
        />
        <ReportRecordSelect
          report={report}
          value={value}
          onChange={(value) => setValue(value as LabeledValueType)}
          disabled={loading || !report}
          style={{ minWidth: 150, width: 'fit-content' }}
        />
        <GenerateSingleButton />
      </Space>
      <ReportSample />
    </Space>
  )
}

export default SingleReports
